import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TacsCodeKreis } from '@entity/tacs-code-kreis';
import { TacsCodeKreisService } from '@service/tacs-code-kreis.service';

export const TacsCodeKreisResolve: ResolveFn<TacsCodeKreis[]> = (route) => {
  return inject(TacsCodeKreisService).getTacsCodeKreis(route.data.variablenartId);
};
